import { render } from "./ProfileDashboard.vue?vue&type=template&id=47b16336"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__